import { AppShell } from '../components/AppShell'
import { useAuth } from '../lib/auth'
import { usePhaseStatus, useScore } from '../lib/api'

function initials(s: string | null | undefined): string {
  if (!s) return '?'
  return s.split(/[\s@]+/).map((w) => w.charAt(0).toUpperCase()).filter(Boolean).slice(0, 2).join('')
}

export function ProfilePage() {
  const { user, account } = useAuth()
  const ps = usePhaseStatus().data
  const score = useScore().data

  const memberSince = account?.startedAt
    ? new Date(account.startedAt).toLocaleDateString('en-IE', { month: 'short', year: 'numeric' })
    : '—'

  return (
    <AppShell page="profile" breadcrumb={<span className="topbar__breadcrumb-current">Profile</span>}>
      <header className="page-header">
        <div className="page-header__main">
          <p className="page-header__eyebrow"><span>Account</span></p>
          <h1 className="page-header__title">Profile</h1>
          <p className="page-header__subtitle">Your public-facing profile and trading snapshot.</p>
        </div>
      </header>

      <div className="settings-content">
        <section className="settings-card">
          <header className="settings-card__header">
            <div className="settings-card__title-group">
              <h2 className="settings-card__title">Public profile</h2>
              <p className="settings-card__description">This is how other traders see you on the leaderboard.</p>
            </div>
          </header>
          <div className="settings-card__body">
            <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-4)', padding: 'var(--space-3) 0' }}>
              <div style={{ width: 64, height: 64, borderRadius: 999, background: 'var(--color-primary-subtle)',
                color: 'var(--color-primary)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 'var(--text-xl)', fontWeight: 600 }}>
                {initials(user?.displayName ?? user?.email)}
              </div>
              <div>
                <div style={{ fontSize: 'var(--text-lg)', fontWeight: 600, color: 'var(--text-primary)' }}>
                  {user?.displayName ?? 'Trader'}
                </div>
                <div style={{ fontSize: 'var(--text-sm)', color: 'var(--text-tertiary)', fontFamily: 'var(--font-mono)' }}>
                  {user?.email}
                </div>
                <div style={{ marginTop: 'var(--space-1)', fontSize: 'var(--text-xs)', color: 'var(--text-tertiary)' }}>
                  Member since {memberSince}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="settings-card">
          <header className="settings-card__header">
            <h2 className="settings-card__title">Trading status</h2>
            <p className="settings-card__description">Current challenge tier and progress snapshot.</p>
          </header>
          <div className="settings-card__body">
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 'var(--space-3)' }}>
              <article className="kpi-card">
                <header className="kpi-card__header"><span className="kpi-card__label">Active tier</span></header>
                <div className="kpi-card__value">{account?.tierCode ? account.tierCode.charAt(0).toUpperCase() + account.tierCode.slice(1) : '—'}</div>
                <p className="kpi-card__detail">{account ? `${account.currentPhase.toUpperCase()}` : 'No active challenge'}</p>
              </article>
              <article className="kpi-card">
                <header className="kpi-card__header"><span className="kpi-card__label">Bets placed</span></header>
                <div className="kpi-card__value">{ps?.betsPlaced ?? 0}</div>
                <p className="kpi-card__detail">{ps ? `${ps.betsRequired} required this phase` : '—'}</p>
              </article>
              <article className="kpi-card">
                <header className="kpi-card__header"><span className="kpi-card__label">Trader score</span></header>
                <div className="kpi-card__value">{score ? score.composite.toFixed(1) : '—'}</div>
                <p className="kpi-card__detail">Composite metric</p>
              </article>
            </div>
          </div>
        </section>
      </div>
    </AppShell>
  )
}
